import { Typography, Link as MuiLink } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { Link, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useMapSearchState } from 'state/useMapSearchState';
import { isIframe, mapSearchResultToMapLocation } from 'shared/utils';
import { usePlaces } from 'features/places/hooks/usePlaces';
import { mapLocationToPlaceAddress } from 'features/places/places.utils';
import { MouseEventHandler } from 'react';
import { useAuthState } from 'state/useAuthState';
import { useSelectedLocationState } from 'state/useSelectedLocationState';
import { MEMBERSHIP_PLANS } from 'features/membership/membership.constants';
import { getPaywallLink } from 'features/membership/membership.utils';

type LocationMarkerLabelProps = {
  label: string;
};

const useStyles = makeStyles()((theme) => ({
  container: {
    width: '100%',
    minWidth: 100,
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(1),
    boxShadow: theme.shadows[1],
  },
  label: {
    marginBottom: theme.spacing(1),
  },
  link: {
    textTransform: 'uppercase',
    fontWeight: theme.typography.fontWeightMedium,
  },
}));

// @todo remove LocationMarkerLabel when removing 'pin_drop_improvements' release flag
export const LocationMarkerLabel = (
  props: LocationMarkerLabelProps,
): JSX.Element => {
  const { label } = props;
  const { classes } = useStyles();
  const { t } = useTranslation();
  const { value } = useMapSearchState();
  const { places } = usePlaces();
  const { showMembershipFeatures } = useAuthState();
  const { setSelectedLocation } = useSelectedLocationState();
  const history = useHistory();

  const handleAddPlace: MouseEventHandler<HTMLAnchorElement> = (event) => {
    if (places.length >= 1 && !showMembershipFeatures) {
      event.preventDefault();
      const paywallLink = getPaywallLink({
        focusedPlan: MEMBERSHIP_PLANS.yearly,
        source: 'location_marker_add_place',
      });
      history.push(paywallLink.url);
      return;
    }
    setSelectedLocation(null);
  };

  return (
    <div className={classes.container}>
      <Typography className={classes.label}>{label}</Typography>
      {!isIframe() && value && (
        <MuiLink
          to={{
            pathname: '/add_place',
            state: mapLocationToPlaceAddress(
              mapSearchResultToMapLocation(value),
            ),
          }}
          component={Link}
          underline="none"
          color="textPrimary"
          className={classes.link}
          onClick={handleAddPlace}
        >
          {t('common.save')}
        </MuiLink>
      )}
    </div>
  );
};
